import { MoonIcon, SunIcon } from 'lucide-react';

import { useSettingsStore } from '@/store';
import { useAppConfig } from '../layouts';
import { Button } from '../ui/button';
import { TextToolTip } from './TextToolTip';

export default function DarkModeToggle({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  const { setThemeMode, themeMode } = useSettingsStore();

  const { colorScheme } = useAppConfig();

  const toggleTheme = () => {
    setThemeMode(themeMode === 'light' ? 'dark' : 'light');
  };

  if (colorScheme !== 'auto') {
    return null;
  }

  if (children) {
    return (
      <div role="button" className={className} onClick={toggleTheme}>
        {children}
      </div>
    );
  }

  return (
    <TextToolTip label={themeMode === 'light' ? 'Dark Mode' : 'Light Mode'}>
      <Button
        variant="ghost"
        size="icon"
        onClick={toggleTheme}
        className={'rounded-full'}
      >
        {themeMode === 'light' ? (
          <MoonIcon className="w-4 h-4" />
        ) : (
          <SunIcon className="w-4 h-4" />
        )}
      </Button>
    </TextToolTip>
  );
}
